import { Badge, Box, Text } from '@mantine/core';
import dayjs from 'dayjs';

import type { VendorAvailabilityData, VendorAvailabilityListItem } from '../types';
import { getVariantKey } from '../helpers';
import { BADGE_VARIANTS } from '../constants';

type StatusBadgeProps = {
  restaurant: VendorAvailabilityListItem;
  vendorAvailabilityData: VendorAvailabilityData;
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ restaurant, vendorAvailabilityData }) => {
  const key = getVariantKey(restaurant);
  const { submittedAt, submittedByEmail } = vendorAvailabilityData.submission || {};

  if (!key) {
    return null;
  }

  const variant = BADGE_VARIANTS[key];

  return (
    <Box ta="right">
      <Badge
        bg={variant.backgroundColor}
        c={variant.color}
        styles={{ label: { textTransform: 'none' } }}
        size="md"
      >
        {variant.getText(vendorAvailabilityData)}
      </Badge>
      {variant.extraText && submittedAt && submittedByEmail && (
        <Text fz="xs">
          on {dayjs(submittedAt).format('MMM D')} by {submittedByEmail}
        </Text>
      )}
    </Box>
  );
};

export default StatusBadge;
